import React, { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import '../styles/Landing.css';
import '@lottiefiles/lottie-player';

function Landing() {
  const controls = useAnimation();
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    controls.start({
      opacity: 1,
      y: 0,
      transition: { duration: 1 },
    });
  }, [controls]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);

    try {
      const response = await fetch(process.env.REACT_APP_FORMSPREE_ENDPOINT, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        form.reset();
        setAlertMessage('Thank you for contacting us!');
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setAlertMessage('There was a problem with your submission. Please try again.');
    }
  };

  return (
    <div id='landingBody'>
      <main className="landingMain">
        <div className="lottie-background">
          <lottie-player
            src="Animation.json"
            background="transparent"
            speed="1"
            style={{ width: '100%', height: '100%' }}
            loop
            autoplay>
          </lottie-player>
        </div>
        <div className="home-container">
          <motion.div
            className="hero"
            initial={{ opacity: 0, y: 30 }}
            animate={controls}
          >
            <h1 className="hero-title">
              Remarkably Cleaner Amazingly Simple.
            </h1>
            <p className="hero-desp">
              Providing spotless Pressure Washing services<br /><br /> Always on time, always smiling
            </p>
          </motion.div>
        </div>
      </main>
      <motion.div
        className="hero"
        initial={{ opacity: 0, y: 30 }}
        animate={controls}
      >
        <div className='contactCard'>
          <h2>Get an Estimate</h2>
          <form onSubmit={handleSubmit} action={process.env.REACT_APP_FORMSPREE_ENDPOINT} method="POST" className='contactFormMain'>
            <div className='contactInput'>
              <p>First Name *</p>
              <input type="text" name="firstName" required />
            </div>
            <div className='contactInput'>
              <p>Last Name *</p>
              <input type="text" name="lastName" required />
            </div>
            <div className='contactInput'>
              <p>Email *</p>
              <input type="email" name="email" required />
            </div>
            <div className='contactInput'>
              <p>Phone *</p>
              <input
                type="text"
                name="phone"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                title="Phone number must be in the format 123-456-7890"
                required
              />
            </div>
            <div className='contactInput'>
              <p>Address *</p>
              <input type="text" name="address" />
            </div>
            <div className='contactInput'>
              <p>City *</p>
              <input type="text" name="city" />
            </div>
            <div className='contactInputText'>
              <p>Tell Us More</p>
              <textarea rows="4" name="message"></textarea>
            </div>
            <div className='contactFormSubmitButton'>
              <button type="submit">Get Clean</button>
            </div>
          </form>
          {alertMessage && <p className="alertMessage">{alertMessage}</p>}
        </div>
      </motion.div>
    </div>
  );
}

export default Landing;
